import { render, staticRenderFns } from "./clinical-training-events-filter.vue?vue&type=template&id=2b52bc83"
import script from "./clinical-training-events-filter.vue?vue&type=script&lang=ts"
export * from "./clinical-training-events-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports